import { render, staticRenderFns } from "./OnlineReservationSettings.vue?vue&type=template&id=615c4318&"
import script from "./OnlineReservationSettings.vue?vue&type=script&lang=js&"
export * from "./OnlineReservationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OnlineReservationSettings.vue"
export default component.exports